import {Business, CurrentUser} from "../../../types/Types";
import {Form} from "react-bootstrap";
import * as React from "react";
import {useState} from "react";
import {convertToFirestoreTimestamp} from "../../../utils/Utils";
import {functions} from "../../../firebase/FirebaseProvider";
import {httpsCallable} from "@firebase/functions";
import {useNavigate} from "react-router";
import TextField from "../../../components/form/TextField";
import NumberField from "../../../components/form/NumberField";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faStar, faTicket} from "@fortawesome/free-solid-svg-icons";
import DateField from "../../../components/form/DateField";
import LocationSelector from "../../../components/form/LocationSelector";

interface Props {
  currentUser: CurrentUser,
  business: Business | undefined,
}

function OffersCreationPage(props: Props) {
  const navigate = useNavigate();
  const [creating, setCreating] = useState<boolean>(false);

  const [location, setLocation] = useState<string>("");
  const [description, setDescription] = useState<string>("");
  const [pointsCost, setPointsCost] = useState<number>();
  const [limitPerCard, setLimitPerCard] = useState<number>();
  const [expiresAt, setExpiresAt] = useState<string>();

  const createOffer = async () => {
    if(!props.business) {
      return
    }
    setCreating(true);
    let expiresAtTimestamp = undefined;
    if(expiresAt) {
      expiresAtTimestamp = convertToFirestoreTimestamp(expiresAt);
    }
    const createOffer = httpsCallable(functions, 'createOffer');
    await createOffer({
      business: props.business.id,
      location: props.business.locations[0],
      description: description,
      pointsCost: pointsCost || 0,
      limitPerCard: limitPerCard || 0,
      expiresAt: expiresAtTimestamp,
    }).then(() => {
      setCreating(false);
      navigate("/offers")
    });
  };

  return (
    <div>
      <Form className={"mb-3"}>
        <LocationSelector business={props.business} setValue={setLocation}/>
        <TextField label={"Description"} subLabel={"For example: Mahou - 330ml bottle"} value={description} setValue={setDescription} required={true} />
        <NumberField label={"Points Cost"} subLabel={"For example: 30 points"} placeholder={""} unit={<FontAwesomeIcon icon={faStar}/>} step={1} value={pointsCost} setValue={setPointsCost} required={true}/>
        <NumberField label={"Usage Limit"} subLabel={"Leave empty for unlimited usages"} placeholder={""} unit={<FontAwesomeIcon icon={faTicket}/>} step={1} value={limitPerCard} setValue={setLimitPerCard} required={false}/>
        <DateField label={"Expires On"} subLabel={"Leave empty for unlimited validity"} value={expiresAt} setValue={setExpiresAt}/>
      </Form>
      {!creating && <div className={"primary-button"} onClick={() => createOffer()}>Create Offer</div>}
      {creating && <div className={"primary-button"}>Creating...</div>}
    </div>
  );
}

export default OffersCreationPage;